import { render, staticRenderFns } from "./Organization.vue?vue&type=template&id=697c189a&"
import script from "./organization-detail.js?vue&type=script&lang=js&"
export * from "./organization-detail.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports